import SeparateLine from '@/shared/Forms/SeparateLine'
import textWidgetImgSrc from '@/assets/images/widgets/text.png'
import lineChartWidgetImgSrc from '@/assets/images/widgets/line-chart.png'
import tableWidgetImgSrc from '@/assets/images/widgets/table.png'
import svgWidgetImgSrc from '@/assets/images/widgets/svg-diagram.png'
import css from '../createWidgetSidePage.module.css'
import Image from '@/shared/Common/Image'
import { IWidget } from '@/pages/Dashboards/dashboards.types.ts'

const options = [
  { src: textWidgetImgSrc, title: 'Текст и переменные', type: 'text' },
  { src: lineChartWidgetImgSrc, title: 'Линейный график', type: 'linear' },
  { src: svgWidgetImgSrc, title: 'SVG диаграмма', type: 'svg' },
  { src: tableWidgetImgSrc, title: 'Таблица', type: 'table' },
]

interface IProps {
  onTypeSelect: (type: IWidget['type']) => void
}

const CreateWidgetSelectTypeContent = (props: IProps) => {
  return (
    <div className="flex-lines gap16">
      <h4 className="text-heading-4">Добавление виджета</h4>
      <SeparateLine />
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
        {options.map((o) => (
          <div key={o.type} className="flex-lines gap8">
            <Image
              src={o.src}
              wrapperClassname={css.widgetImage}
              alt={o.title}
              onClick={() => props.onTypeSelect(o.type as any)}
              style={{ width: '100%', height: '100%' }}
            />
            <p className="text-nm">{o.title}</p>
          </div>
        ))}
      </div>
    </div>
  )
}

export default CreateWidgetSelectTypeContent
